import { Dispatch } from 'redux';
import FacebookErrorController from '../controllers/FacebookErrorController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import Actions from './actions';
import CrudActionContainer from './CrudActionContainer';
import { NOT_FOUND } from '@mm/constants/status-codes';

class FacebookErrorCRUDActions extends CrudActionContainer {
  constructor() {
    super('FACEBOOK_ERROR');
  }

  retrieveAll(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));
      try {
        const { facebookErrors } = await FacebookErrorController.getAll(
          facebookPageId,
        );
        dispatch({
          type: Actions.SET_FACEBOOK_PAGE_ERRORS,
          payload: { id: facebookPageId, facebookErrors },
        });
        return facebookErrors;
      } catch (e) {
        await commonHandler(dispatch)(e);
      }
    };
  }

  delete(facebookPageId: number, facebookErrorId: number, ignore: boolean) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));
      try {
        await FacebookErrorController.deleteFacebookError(
          facebookPageId,
          facebookErrorId,
          ignore,
        );
        dispatch({
          type: Actions.REMOVE_FACEBOOK_PAGE_ERROR,
          payload: { facebookPageId, facebookErrorId },
        });
      } catch (e) {
        if (e instanceof Response) {
          if (e.status === NOT_FOUND) {
            return;
          }
        }
        commonHandler(dispatch)(e);
      }
    };
  }
}

const facebookErrorCRUDActions = new FacebookErrorCRUDActions();

export default facebookErrorCRUDActions;

export const useFacebookErrorCRUDActions = getActionHookBuilder(
  facebookErrorCRUDActions,
  ['retrieveAll', 'delete'],
);
